import { render, staticRenderFns } from "./ConfigMap.vue?vue&type=template&id=18a25d2a&scoped=true&"
import script from "./ConfigMap.vue?vue&type=script&lang=js&"
export * from "./ConfigMap.vue?vue&type=script&lang=js&"
import style0 from "./ConfigMap.vue?vue&type=style&index=0&id=18a25d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a25d2a",
  null
  
)

export default component.exports